import { Link } from 'react-router-dom';
import SEO from '../../components/base/SEO';

export default function EmpresaPage() {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "VACIADOS MARIUS",
    "image": "https://public.readdy.ai/ai/img_res/6bea04c8-eed4-4f8d-a07d-4399896150a0.png",
    "@id": `${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/#organization`,
    "url": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/",
    "telephone": "+34936940041",
    "email": "vaciadosmarius@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Barcelona",
      "addressRegion": "Cataluña",
      "addressCountry": "ES"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.3851",
      "longitude": "2.1734"
    },
    "areaServed": ["Barcelona", "L'Hospitalet de Llobregat", "Badalona", "Santa Coloma de Gramenet"],
    "priceRange": "€€",
    "sameAs": "https://share.google/FizsQeezE7RkuyEkt"
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": import.meta.env.VITE_SITE_URL || "https://vaciado-pisos-barcelona.vaciadosmarius.com.es/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Empresa",
        "item": `${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/empresa`
      }
    ]
  };

  return (
    <>
      <SEO
        title="Empresa de Vaciado de Pisos en Barcelona | Quiénes Somos | VACIADOS MARIUS"
        description="Más de 15 años vaciando pisos en Barcelona con discreción y profesionalidad. Conoce nuestro equipo, método de trabajo y compromiso con cada cliente."
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://vaciado-pisos-barcelona.vaciadosmarius.com.es'}/empresa`}
        keywords="empresa vaciado pisos Barcelona, equipo profesional, vaciado discreto Barcelona"
        geoRegion="ES-CT"
        geoPlacename="Barcelona"
        geoPosition="41.3851;2.1734"
        jsonLd={[localBusinessSchema, breadcrumbSchema]}
      />

      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="text-sm text-gray-600 mb-8">
              <Link to="/" className="hover:text-teal-600 cursor-pointer">Inicio</Link>
              <span className="mx-2">&gt;</span>
              <span className="text-gray-900">Empresa</span>
            </nav>

            <div className="grid lg:grid-cols-5 gap-12 items-center">
              <div className="lg:col-span-2">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                  Vaciado de pisos con experiencia y confianza
                </h1>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Desde 2008 ayudando a familias y propietarios en Barcelona a vaciar viviendas de forma profesional, discreta y responsable.
                </p>
                <a
                  href="/contacto"
                  className="inline-flex items-center space-x-2 px-8 py-4 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span>CONTACTAR</span>
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>

              <div className="lg:col-span-2">
                <img
                  src="https://public.readdy.ai/ai/img_res/04a44308463835e6bad8a6ba364ca6fd.jpg"
                  alt="Equipo VACIADOS MARIUS"
                  className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>

              <div className="lg:col-span-1">
                <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-gray-900">Nuestros valores</h3>
                    <i className="ri-arrow-right-up-line text-gray-400"></i>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="relative">
                    <img
                      src="https://readdy.ai/api/search-image?query=Workers%20carefully%20protecting%20apartment%20stairwell%20with%20thick%20cardboard%20padding%20and%20protective%20materials%2C%20professional%20team%20installing%20corner%20guards%20and%20floor%20protection%2C%20attention%20to%20detail%20in%20building%20protection%2C%20Barcelona%20apartment%20building%20interior&width=400&height=300&seq=protection-001&orientation=landscape"
                      alt="Protección"
                      className="w-full h-32 object-cover object-top rounded-xl"
                    />
                    <span className="absolute bottom-3 left-3 px-3 py-1 bg-white rounded-full text-xs font-semibold">
                      Protección
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="relative">
                      <img
                        src="https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20carefully%20wrapping%20delicate%20furniture%20with%20bubble%20wrap%20and%20protective%20blankets%2C%20detailed%20view%20of%20professional%20furniture%20protection%20technique%2C%20gentle%20handling%20of%20valuable%20items%2C%20care%20and%20precision%20in%20moving%20process&width=300&height=200&seq=care-001&orientation=squarish"
                        alt="Cuidado"
                        className="w-full h-24 object-cover object-top rounded-xl"
                      />
                      <span className="absolute bottom-2 left-2 px-2 py-1 bg-white rounded-full text-xs font-semibold">
                        Cuidado
                      </span>
                    </div>
                    <div className="relative">
                      <img
                        src="https://readdy.ai/api/search-image?query=Team%20member%20with%20clipboard%20and%20checklist%20planning%20clearance%20logistics%2C%20professional%20planning%20and%20organization%2C%20detailed%20inventory%20list%20and%20scheduling%2C%20systematic%20approach%20to%20apartment%20clearance%2C%20organized%20workflow&width=300&height=200&seq=planning-001&orientation=squarish"
                        alt="Planificación"
                        className="w-full h-24 object-cover object-top rounded-xl"
                      />
                      <span className="absolute bottom-2 left-2 px-2 py-1 bg-white rounded-full text-xs font-semibold">
                        Planificación
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quiénes Somos */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  Más de 15 años vaciando pisos en Barcelona
                </h2>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    <strong>VACIADOS MARIUS</strong> nació en 2008 con una misión clara: ofrecer un servicio de <strong>vaciado de pisos en Barcelona</strong> que combinara profesionalidad, discreción y transparencia. Desde entonces, hemos ayudado a más de 500 familias y propietarios a vaciar sus viviendas en situaciones muy diversas.
                  </p>
                  <p>
                    Entendemos que cada <strong>vaciado de vivienda</strong> es único. Ya sea por una herencia tras un fallecimiento, una reforma integral, un fin de contrato de alquiler o simplemente la necesidad de liberar espacio, tratamos cada caso con el respeto y la atención que merece.
                  </p>
                  <p>
                    Nuestro equipo está formado por profesionales experimentados que conocen a fondo el área metropolitana de Barcelona: desde el centro de la ciudad hasta <strong>L'Hospitalet</strong>, <strong>Badalona</strong>, <strong>Santa Coloma</strong>, <strong>Cornellà</strong> y todos los municipios de la provincia. Consulta nuestra <a href="/#cobertura" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">cobertura geográfica completa</a>.
                  </p>
                  <p>
                    Lo que nos diferencia es nuestra transparencia. No prometemos vaciados gratis a todo el mundo. Evaluamos cada piso individualmente y te explicamos con claridad si el valor de los muebles y objetos puede compensar el coste del trabajo. Si no es así, te damos un presupuesto justo y detallado. Sin sorpresas.
                  </p>
                  <p>
                    Consulta nuestros <Link to="/servicios" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">servicios de vaciado</Link> completos para conocer todas las opciones que ofrecemos.
                  </p>
                </div>
              </div>

              <div className="bg-teal-50 rounded-2xl p-8">
                <blockquote className="text-xl font-serif italic text-gray-800 mb-6">
                  "Cada vaciado es único. Tratamos cada vivienda como si fuera nuestra, con respeto y profesionalidad."
                </blockquote>
                <div className="space-y-6 text-gray-700">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Experiencia local</h4>
                      <p className="text-sm">Conocemos Barcelona y su área metropolitana como nadie</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Equipo profesional</h4>
                      <p className="text-sm">Formados en logística, protección y trato con clientes</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Transparencia total</h4>
                      <p className="text-sm">Presupuestos claros, sin letra pequeña ni costes ocultos</p>
                    </div>
                  </div>
                </div>
                <div className="mt-6 pt-6 border-t border-teal-200">
                  <a href="/faq" className="text-teal-600 hover:text-teal-700 font-semibold text-sm cursor-pointer">
                    ¿Tienes dudas? Consulta nuestras preguntas frecuentes →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Cómo Trabajamos */}
        <section id="como-trabajamos" className="bg-gray-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
              Nuestro método de trabajo
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                  <i className="ri-search-eye-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Evaluación sin compromiso</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Analizamos el contenido del piso, identificamos objetos de valor y te damos una propuesta clara en 24-48 horas.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                  <i className="ri-shield-check-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Protección de zonas comunes</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Protegemos escaleras, ascensor, paredes y suelos con materiales profesionales para evitar cualquier daño.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                  <i className="ri-truck-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Logística y carga profesional</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Desmontamos, envolvemos y cargamos con técnicas profesionales. Coordinamos horarios y accesos para máxima eficiencia.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                  <i className="ri-recycle-line text-teal-600 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Gestión responsable de residuos</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Trabajamos según normativa vigente y utilizamos gestores autorizados cuando aplique. Los muebles y objetos reutilizables se destinan a reventa o donación. Te podemos facilitar documentación si la necesitas.
                </p>
              </div>
            </div>
            <div className="text-center mt-12">
              <a href="/servicios" className="inline-flex items-center space-x-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer">
                <span>Descubre todos nuestros servicios de vaciado</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        {/* Casos Típicos */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
              Situaciones en las que te ayudamos
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <a href="/servicios#herencias" className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Respectful%20and%20sensitive%20scene%20of%20apartment%20clearance%20after%20bereavement%2C%20soft%20muted%20tones%2C%20gentle%20handling%20of%20personal%20belongings%20and%20memories%2C%20compassionate%20professional%20service%2C%20dignified%20and%20careful%20approach%20to%20estate%20clearance%2C%20emotional%20support%20during%20difficult%20time&width=600&height=700&seq=inheritance-001&orientation=portrait"
                  alt="Herencias y fallecimientos"
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase">
                  HERENCIAS
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                  <h3 className="text-white font-bold text-xl mb-2">Herencias y fallecimientos</h3>
                  <p className="text-white/80 text-sm">
                    Máxima discreción y respeto en momentos difíciles. Te ayudamos a identificar objetos valiosos.
                  </p>
                </div>
              </a>

              <a href="/servicios#reformas" className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Empty%20apartment%20with%20keys%20on%20counter%20ready%20for%20handover%2C%20clean%20vacant%20rental%20property%2C%20end%20of%20lease%20situation%2C%20keys%20and%20rental%20documents%20on%20kitchen%20counter%2C%20bright%20empty%20rooms%20ready%20for%20new%20tenant%2C%20professional%20property%20handover%20scene&width=600&height=700&seq=rental-end-001&orientation=portrait"
                  alt="Fin de contrato de alquiler"
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase">
                  ALQUILERES
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                  <h3 className="text-white font-bold text-xl mb-2">Fin de contrato de alquiler</h3>
                  <p className="text-white/80 text-sm">
                    Vaciado rápido para cumplir plazos de entrega. Coordinación con propietarios e inquilinos.
                  </p>
                </div>
              </a>

              <a href="/servicios#reformas" className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Apartment%20under%20renovation%20with%20construction%20materials%20and%20tools%2C%20empty%20space%20ready%20for%20remodeling%20work%2C%20renovation%20in%20progress%2C%20cleared%20apartment%20prepared%20for%20contractors%2C%20construction%20site%20preparation%2C%20professional%20renovation%20clearance&width=600&height=700&seq=renovation-001&orientation=portrait"
                  alt="Reformas integrales"
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-lime-400 text-gray-900 rounded-full text-xs font-bold uppercase">
                  REFORMAS
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                  <h3 className="text-white font-bold text-xl mb-2">Reformas integrales</h3>
                  <p className="text-white/80 text-sm">
                    Liberamos el espacio para que los contratistas puedan empezar. Coordinación perfecta.
                  </p>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Transparencia Section */}
        <section className="bg-gradient-to-b from-amber-900 to-amber-950 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-6">
              <span className="inline-block px-4 py-1 bg-purple-400/20 text-purple-200 rounded-full text-xs font-semibold uppercase tracking-wide">
                NUESTRO COMPROMISO
              </span>
            </div>
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight">
                  Transparencia en cada paso
                </h2>
                <div className="space-y-4 text-white/90 leading-relaxed">
                  <p>
                    En <strong>VACIADOS MARIUS</strong> no prometemos lo que no podemos cumplir. El <strong>vaciado gratis</strong> solo es posible cuando los muebles, electrodomésticos u objetos tienen valor suficiente para compensar nuestros costes de trabajo, transporte y gestión.
                  </p>
                  <p>
                    En cuanto a la <a href="/servicios#compra-muebles" className="text-teal-400 hover:text-teal-300 underline cursor-pointer">compra de muebles</a>, solo adquirimos piezas de diseño firmado (Eames, Thonet, Cassina, etc.) o antigüedades auténticas de más de 100 años. No compramos muebles comunes de Ikea, Conforama o similares, aunque podemos retirarlos dentro del servicio de vaciado con presupuesto.
                  </p>
                  <p>
                    Te damos presupuestos claros, sin letra pequeña ni costes ocultos. Si algo cambia durante el proceso, te lo comunicamos inmediatamente.
                  </p>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20handshake%20and%20contract%20signing%20between%20client%20and%20service%20provider%2C%20transparent%20business%20agreement%2C%20trust%20and%20professionalism%2C%20clear%20documentation%20and%20honest%20communication%2C%20business%20partnership%20and%20commitment%2C%20professional%20service%20contract&width=800&height=600&seq=contract-001&orientation=landscape"
                  alt="Transparencia"
                  className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
                />
                <div className="absolute bottom-8 right-8 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
                  <p className="text-6xl font-serif font-bold text-gray-900 mb-2">0€</p>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    Sorpresas en el presupuesto<br />
                    Todo claro desde el inicio
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-12">
              <a
                href="/faq"
                className="inline-block px-8 py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                VER PREGUNTAS FRECUENTES
              </a>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="bg-white py-20">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">
              ¿Hablamos de tu proyecto?
            </h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
              <a
                href="tel:+34936940041"
                className="flex items-center space-x-3 px-8 py-4 bg-teal-600 text-white rounded-full text-base font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>LLAMAR 936 94 00 41</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 px-8 py-4 bg-green-600 text-white rounded-full text-base font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
                <span>WHATSAPP 633 759 649</span>
              </a>
            </div>
            <p className="text-gray-600">
              O visita nuestra <Link to="/contacto" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">página de contacto</Link> para solicitar presupuesto sin compromiso
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
